import type { ResponseMESF } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import type { RowClassParams, RowStyle } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { backgroundColor } from "../../../../../../utils/theme";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { readPhasesFromPLC } from "../../../repositories/eaf.repositories";
import { useTheme } from "@mui/material/styles";
import { eafDETablesStyles } from "../styles/eafDETablesStyles";
import { useTableData } from "./hooks/usePhasesTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TablePhases = () => {
  const theme = useTheme();
  const styles = eafDETablesStyles(theme);

  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { refreshData } = useEAFDataEntryActions();

  const getRowStyle = (params: RowClassParams): RowStyle | undefined => {
    if (params.data.End === null || params.data.End === undefined) {
      return { backgroundColor: backgroundColor };
    }
    return undefined;
  };

  const readAutomaticPhases = async (value?: string) => {
    if (value === "OK") {
      const resp = await readPhasesFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read phases from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read phases from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  const { columns } = useTableData();
  return (
    <Paper>
      <Box padding={1} sx={styles.agGridBox}>
        <AgGridReact
          rowData={deProcess?.phases}
          columnDefs={columns}
          defaultColDef={{ ...defaultColDef, sortable: false }}
          getRowStyle={getRowStyle}
          loadingOverlayComponent={CenteredLazyLoading}
          {...defaultGridOptions}
        />
        <AgGridFooterActions
          hasMaxItems={true}
          readFromPLC={readAutomaticPhases}
          table="phases"
          show={{ new: false, plc: true }}
        />
      </Box>
    </Paper>
  );
};
